//ONLINE CONSULTANT

// $('.onlineconsultant').draggable({
//     containment: document.body
// }).filter('#dragH').draggable("option", "axis", "x");

// $('.onlineconsultant').ready(function() {
//     console.log('OnlineConsultant is ready!');
//     sessionStorage.setItem('chat_id','0'); 
//     sessionStorage.setItem('oc_chat','0'); 
//     sessionStorage.setItem('oc_type_message','0'); 
//     setInterval(function() {
//         if(sessionStorage.getItem('oc_chat') != '0' || sessionStorage.getItem('oc_chat') !== null){
//             loadMessages(false,false); 
//         }
//     }, 3000);
// });

$(document).on('keyup', '#oc_input', function (e) {
    if (e.which  === 13) {
        if($('#oc_input').val()){
            $.ajax({
                url: '/onlinechat',
                type: 'POST',
                data: {
                    _token: $('meta[name="csrf-token"]').attr('content'),
                    action: 'send_msg', 
                    chat_id: sessionStorage.getItem('oc_chat'),
                    message: $('#oc_input').val(), 
                    service_msg:sessionStorage.getItem('oc_type_message')
                },
                dataType: 'JSON',
                success: function (data) { 
                    $('#oc_alert').hide();
                    $('#get_themes_id').html(data.test_html);
                    $('#get_topics_stats').html(data.topics_html);
                    $('#oc_input').val('');
                    loadMessages(true,false);
                    document.getElementById('oc_message_block').scrollTop = document.getElementById('oc_message_block').scrollHeight;
                },
                error: function(data, exception){
                    errorAlert(data, exception);
                }
            });
        }
    }
});


$(document).on('click', '.oc_chat', function () {
    sessionStorage.setItem('oc_chat',this.getAttribute('chat_id')); 
    sessionStorage.setItem('oc_type_message',this.getAttribute('service_msg')); 
    $('#oc_chats_block').hide(); 
    $('#oc_curators_block').show();
    $('#oc_message_block').show();
    $('#oc_input').show();
    loadMessages(true,true);
});


$(document).on('click', '.oc_curator', function () {
    sessionStorage.setItem('oc_chat','0');
    sessionStorage.setItem('oc_type_message','0'); 
    loadChats();
    $('#oc_chats_block').show();
    $('#oc_curators_block').hide();
    $('#oc_message_block').hide();
    $('#oc_input').hide();
});

function loadMessages(scrolldown = true,thatfirst = false){
    if($('#oc_message_block').is(":visible")){
        $.ajax({
            url: '/onlinechat',
            type: 'POST',
            data: {
                _token:$('meta[name="csrf-token"]').attr('content'),
                action:'messages',
                chat_id:sessionStorage.getItem('oc_chat'),
                service_msg:sessionStorage.getItem('oc_type_message')
            },
            dataType: 'JSON',
            success: function (data) {
                $('#oc_alert').hide();
                $('#oc_input').show();
                data.messages.forEach(function(message) {
                    if(message.date_msg != 'non'){
                        $('#oc_message_block').append("<div class = 'oc_messages_date'>"+message.date_msg+"</div>"); 
                    } 
                    if(message.status == '2'){
                        $('#oc_message_block').append("<div class = 'oc_messages_date'>"+message.name+" подключился к чату</div>");
                    }else if(message.status == '1' || message.status == '3'){
                        $('#oc_message_block').append("<div class = 'oc_message_"+message.typechat+"'><p>"+message.text+"</p><div class = 'oc_message_date'>"+message.time+"</div></div>");
                    }
                }); 
            },
            error: function(data, exception){
                errorAlert(data, exception);
            }
        }); 
    }
} 

function loadChats(){
    $.ajax({
        url: '/onlinechat',
        type: 'POST',
        data: {
            _token: $('meta[name="csrf-token"]').attr('content'), 
            action: 'chats'
        },
        dataType: 'JSON',
        success: function (data) { 
            if(data.status == 'success'){
                $('#oc_alert').hide();
                $('#oc_chats_block').empty();
                data.chatsarray.forEach(function(chatsinfo) {
                    if(chatsinfo.arrayItems.length != 0){ 
                        $('#oc_chats_block').append("<div class='oc_chat'><p>"+chatsinfo.title+"</p></div>");
                        chatsinfo.arrayItems.forEach(function(chat) { 
                            $('#oc_chats_block').append("<div class='oc_chat' id='"+chat.id+"' service_msg='"+chatsinfo.service+"'><p>"+chat.title+"</p></div>");
                        });
                    }
                });
            }
        },
        error: function(data, exception){
            errorAlert(data, exception);
        }
    }); 
}


function errorAlert(data,exception,classname = null){ 
    $("#oc_alert").removeClass();
    $('#oc_alert').show();
    if(classname != null){
        $('#oc_alert').html(data); 
        $('#oc_alert').addClass(classname);
    }else if(data.status == 'newchat'){
        $('#oc_alert').html('Подключение к чату');
        $('#oc_alert').addClass('success');
    }else if (data.status === 0) {
        $('#oc_alert').html('Нет соединения.\n Проверьте подключение к интернету');
        $('#oc_alert').addClass('error');
    } else if (data.status == 404) { 
        $('#oc_alert').html('Сервер недоступен');
        $('#oc_alert').addClass('error');
    } else if (data.status == 500) {
        $('#oc_alert').html('Внутренняя ошибка сервера');
        $('#oc_alert').addClass('warning');
    } else if (exception === 'parsererror') {
        $('#oc_alert').html('Requested JSON parse failed.');
        $('#oc_alert').addClass('warning');
    } else if (exception === 'timeout') {
        $('#oc_alert').html('Время ожидания истекло');
        $('#oc_alert').addClass('warning');
    } else if (exception === 'abort') {
        $('#oc_alert').html('Запрос остановлен');
        $('#oc_alert').addClass('warning');
    } else {
        $('#oc_alert').html('Неизвестная ошибка.\n' + data.responseText);
        $('#oc_alert').addClass('error');
    }
    
}

$(document).on('click', '.oc_header', function () {
    if($('#oc_body').is(":hidden")){
        $('#oc_arrow').removeClass('md-chevron-up');
        $('#oc_arrow').addClass('md-chevron-down');
        $('#oc_body').show();
        document.getElementById('oc_message_block').scrollTop = document.getElementById('oc_message_block').scrollHeight;
        $('#oc_header').css('cursor','move');
        if(sessionStorage.getItem('oc_chat') == '0' || sessionStorage.getItem('oc_chat') == null){
            loadChats();
            $('#oc_chats_block').show();
            $('#oc_curators_block').hide();
            $('#oc_message_block').hide();
            $('#oc_input').hide();
        }else{
            $('#oc_chats_block').hide();
            $('#oc_curators_block').show();
            $('#oc_message_block').show();
            $('#oc_input').show();
            loadMessages(true,true);
            document.getElementById('oc_message_block').scrollTop = document.getElementById('oc_message_block').scrollHeight;
        }
    }else{ 
        $('#oc_header').css('cursor','pointer');
        $('#oc_body').hide(); 
        $('#oc_curators_block').hide();
        $('#oc_arrow').removeClass('md-chevron-down');
        $('#oc_arrow').addClass('md-chevron-up');
    }
});
//END ONLINE CONSULTANT
